import { Navigate, Outlet, useSearchParams } from "react-router-dom"; // Add useSearchParams
import { useAuth } from "../../context/AuthContext";

const AuthLayout = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams(); // Hook to read URL params

  // If user is already logged in...
  if (user) {
    const returnUrl = searchParams.get("returnUrl");
    console.log("returnUrl from auth", returnUrl);

    // 1. If there is a returnUrl, go there!
    if (returnUrl) {
      return <Navigate to={decodeURIComponent(returnUrl)} replace />;
    }

    // 2. Otherwise, go to dashboard
    return <Navigate to="/dashboard/home" replace />;
  }

  return <Outlet />;
};

export default AuthLayout;